var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticClass:"mx-auto",attrs:{"src":require(`@/assets/images/insurers/${_vm.insurer.logo}`),"width":_vm.width,"height":_vm.height,"contain":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }